// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__w-e7r","nav1":"navbar_nav1__7tq83","img1":"navbar_img1__VZ1xJ","nav2":"navbar_nav2__nzS14"};